import request from '@/utils/request';

export const CONVERSATIONS = 'CONVERSATIONS';
export const CONVERSATIONS_LOAD_MORE = 'CONVERSATIONS_LOAD_MORE';
export const CONVERSATIONS_HEADER = 'CONVERSATIONS_HEADER';
export const READ_CONVERSATION = 'READ_CONVERSATION';
export const SHOW_CONVERSATION = 'SHOW_CONVERSATION';
export const MESSAGES = 'MESSAGES';
export const SEND_MESSAGE = 'SEND_MESSAGE';
export const SMS_PLANS = 'SMS_PLANS';
export const SMS_SUBSCIPTIONS = 'SMS_SUBSCIPTIONS';
export const SMS_SUBSCIPTION = 'SMS_SUBSCIPTION';
export const SMS_PENDING_COMPANY_SUBSCIPTION = 'SMS_PENDING_COMPANY_SUBSCIPTION';
export const SMS_SUBSCIPTION_COMPANY = 'SMS_SUBSCIPTION_COMPANY';
export const SMS_USAGE = 'SMS_USAGE';
export const SMS_LICENSES = 'SMS_LICENSES';
export const SMS_LICENSE = 'SMS_LICENSE';
export const SMS_ORDERS = 'SMS_ORDERS';
export const SMS_ORDER = 'SMS_ORDER';
export const PHONE_VERIFICATIONS = 'PHONE_VERIFICATIONS';
export const EMAIL_VERIFICATIONS = 'EMAIL_VERIFICATIONS';

export const updatePermission = body => async () =>
  await request({
    path: `/v1/sms/update_permission`,
    method: 'POST',
    body: body
  });

export const fetchConversationsForHeader = body => async dispatch => {
  const response = await request({
    path: `/v1/sms/fetch_conversations`,
    method: 'POST',
    body
  });

  dispatch({
    payload: response,
    type: CONVERSATIONS_HEADER
  });
};

export const fetchConversations =
  (body, options = {}) =>
  async dispatch => {
    const response = await request({
      path: `/v1/sms/fetch_conversations`,
      method: 'POST',
      body
    });

    let type = CONVERSATIONS;
    if (options.type === 'load_more') {
      type = CONVERSATIONS_LOAD_MORE;
    }

    dispatch({
      payload: response,
      type
    });
  };

export const readConversation = body => async () =>
  await request({
    path: `/v1/sms/read_conversation`,
    method: 'POST',
    body: body
  });

export const showConversation =
  ({ contact_id }) =>
  async dispatch => {
    const response = await request({
      path: `/v1/sms/show_conversation`,
      query: { contact_id }
    });
    dispatch({
      payload: response,
      type: SHOW_CONVERSATION
    });
  };

export const fetchMessages = body => async dispatch => {
  const response = await request({
    path: `/v1/sms/fetch_messages`,
    method: 'POST',
    body
  });
  dispatch({
    payload: response,
    type: MESSAGES
  });
};

export const sendMessage = body => async () => {
  const formDataBody = new FormData();
  formDataBody.append('contact_id', body.contact_id);
  formDataBody.append('message_to', body.message_to);
  formDataBody.append('message_content', body.message_content);
  if (body.campaign_trigger_id) formDataBody.append('campaign_trigger_id', body.campaign_trigger_id);
  formDataBody.append('file', body.file);
  formDataBody.append('mms', body.mms);
  formDataBody.append('is_mss', body.is_mss);

  return await request({
    path: `/v1/sms/send_message`,
    method: 'POST',
    formData: true,
    formDataBody
  });
};

export const fetchSmsPlans = () => async dispatch => {
  const response = await request({
    path: `/v1/sms/sms_plans`
  });
  dispatch({ payload: response, type: SMS_PLANS });
};

export const fetchSmsEnterprisePlans = () => async dispatch => {
  const response = await request({
    path: `/v1/sms/sms_plans/enterprise`
  });
  dispatch({ payload: response, type: SMS_PLANS });
};

export const fetchSmsSubscriptions =
  ({ q, order, order_field, page, limit, active, mine }) =>
  async dispatch => {
    const response = await request({
      path: `/v1/sms/sms_subscriptions`,
      method: 'GET',
      query: { q, order, order_field, page, limit, active, mine }
    });
    dispatch({
      payload: response,
      type: SMS_SUBSCIPTIONS
    });
  };

export const fetchSmsSubscription =
  ({ id }) =>
  async dispatch => {
    const response = await request({
      path: `/v1/sms/sms_subscriptions/${id}`
    });
    dispatch({
      payload: response,
      type: SMS_SUBSCIPTION
    });
  };

export const fetchSmsPendingCompanySubscription = () => async dispatch => {
  const response = await request({
    path: `/v1/sms/sms_subscriptions/pending_company_subscription`
  });
  dispatch({
    payload: response,
    type: SMS_PENDING_COMPANY_SUBSCIPTION
  });
};

export const createSmsSubscription = body => async () =>
  await request({
    path: `/v1/sms/sms_subscriptions`,
    method: 'POST',
    body
  });

export const updateSmsSubscription = (id, body) => async () =>
  await request({
    path: `/v1/sms/sms_subscriptions/${id}`,
    method: 'PATCH',
    body
  });

export const cancelSmsSubscription = (id, type) => async () =>
  await request({
    path: `/v1/sms/sms_subscriptions/${id}/cancel`,
    method: 'POST',
    body: { type }
  });

export const fetchSmsActiveSubscription = type => async dispatch => {
  const response = await request({
    path: `/v1/sms/sms_subscriptions_active`,
    query: { type }
  });
  dispatch({
    payload: response && response.data ? response : { data: {} },
    type: type && type === 'company' ? SMS_SUBSCIPTION_COMPANY : SMS_SUBSCIPTION
  });
};

export const fetchUsage = body => async dispatch => {
  const response = await request({
    path: `/v1/sms/sms_subscriptions_usage`
  });
  dispatch({
    payload: response,
    type: SMS_USAGE
  });
};

export const fetchSmsLicenses = body => async dispatch => {
  const response = await request({
    path: `/v1/sms/sms_licenses`
  });
  dispatch({
    payload: response,
    type: SMS_LICENSES
  });
};

export const updateSmsLicense = (id, body) => async () =>
  await request({
    path: `/v1/sms/sms_licenses/${id}`,
    method: 'PATCH',
    body
  });

export const orderSmsLicenses = body => async () =>
  await request({
    path: `/v1/sms/sms_licenses_order`,
    method: 'POST',
    body
  });

export const fetchSmsOrders = body => async dispatch => {
  const response = await request({
    path: `/v1/sms/sms_orders`
  });
  dispatch({
    payload: response,
    type: SMS_ORDERS
  });
};

export const fetchSmsOrder = id => async dispatch => {
  const response = await request({
    path: `/v1/sms/sms_orders/${id}`
  });
  dispatch({
    payload: response,
    type: SMS_ORDER
  });
};

export const mobileValidationPurchase = body => async () =>
  await request({
    path: `/v1/sms/mobile_validation_purchase`,
    method: 'POST',
    body
  });

export const mobileValidationSingle = body => async () =>
  await request({
    path: `/v1/sms/mobile_validation_single`,
    method: 'POST',
    body
  });

export const mobileValidationBulk = body => async () =>
  await request({
    path: `/v1/sms/mobile_validation_bulk`,
    method: 'POST',
    body
  });

export const emailValidationBulk = body => async () =>
  await request({
    path: `/v1/sms/email_validation_bulk`,
    method: 'POST',
    body
  });

export const fetchPhoneVerifications =
  ({ limit, q, page, order_field, order }) =>
  async dispatch => {
    const response = await request({
      path: `/v1/sms/phone_verifications`,
      query: { limit, order_field, order, q, page }
    });
    dispatch({
      payload: response,
      type: PHONE_VERIFICATIONS
    });
  };

export const fetchEmailVerifications =
  ({ limit, q, page, order_field, order }) =>
  async dispatch => {
    const response = await request({
      path: `/v1/sms/email_verifications`,
      query: { limit, order_field, order, q, page }
    });
    dispatch({
      payload: response,
      type: EMAIL_VERIFICATIONS
    });
  };
